<template>
  <div>
    <v-row justify="center">
      <v-col>
        <h2 class="success--text text-center">
          <v-icon color="success"> mdi-check-circle</v-icon> Products to Upload
        </h2>
        <p class="basic--text text-center">Please review the products</p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-data-table
          dense
          :items="products"
          :headers="headers"
          :single-expand="true"
          :expanded.sync="expanded"
          show-expand
          :footer-props="{
            'items-per-page-options': [15, 50, 100, 150, 200],
          }"
        >
          <template v-slot:[`item.Photos`]="{ item }">
            <td>
              <v-card style="max-width: 50px" flat>
                <expandable-image :src="item.Photos[0]"> </expandable-image>
              </v-card>
            </td>
          </template>
          <template v-slot:[`item.Size`]="{ item }">
            <td v-if="item.Size">
              {{ Object.values(item.Size)[0] }}
            </td>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <ProductInfo :product="item"></ProductInfo>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1"
        ><v-btn outlined color="error" @click="getProductsToFix">
          <v-icon left>mdi-arrow-left-bold-outline</v-icon>
          Back
        </v-btn></v-col
      >
      <v-spacer></v-spacer>
      <v-col cols="1"
        ><v-btn
          outlined
          color="success"
          @click="goToTranslations"
          :disabled="products.length == 0"
          >Next <v-icon right>mdi-arrow-right-bold-outline</v-icon></v-btn
        ></v-col
      >
    </v-row>
  </div>
</template>

<script>
import ProductInfo from "../organisms/ProductInfo.vue";

export default {
  name: "ProductsToUpload",
  props: {
    products: Array,
  },
  components: {
    ProductInfo,
  },
  data: () => ({
    headers: [
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "Photo", value: "Photos", class: "footer" },
      { text: "Category", value: "Category", class: "footer" },
      { text: "Style code", value: "StyleCode", class: "footer" },
      { text: "Style name", value: "StyleName", class: "footer" },
      {
        text: "Manufacturer color",
        value: "ManufacturerColor",
        class: "footer",
      },
      { text: "Real color", value: "RealColor", class: "footer" },
      { text: "Size", value: "Size", class: "footer" },
    ],
    expanded: [],
  }),
  computed: {},
  methods: {
    goToTranslations() {
      this.$emit("goToTranslations");
    },
    getProductsToFix() {
      this.$emit("getProductsToFix");
    },
  },
};
</script>